import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomCheckoutService } from '@checkout/feature';
import { CustomOrder } from '@order/const';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'sd-order-confirmation-info-buttons',
  templateUrl: './order-confirmation-info-buttons.component.html',
  styleUrls: ['./order-confirmation-info-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorOrderConfirmationInfoButtonsComponent implements OnInit {
  order$: Observable<CustomOrder>;

  constructor(private customCheckoutService: CustomCheckoutService) {}

  ngOnInit(): void {
    this.order$ = this.customCheckoutService
      .getOrderDetails()
      .pipe(filter<CustomOrder>((order) => Object.keys(order || {}).length > 0));
  }
}
